import React from "react";
import { PageShell } from "../components/PageShell";
export function Participate() {
  return <PageShell title="Participer" intro="Bénévoles, adhérents, pilotes : rejoignez l'aventure du cinquantenaire." data-id="element-193" data-mp="vh6sh4briy08" />;
}